module.exports = __webpack_public_path__ + "assets/assets/images/illustrations/contact.e2094414.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/illustrations/contact.png
// module id = 552
// module chunks = 0